import React, { memo } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Stack, Alert } from "investira.react.components";
import { validators, formats } from "investira.sdk";
import { Link } from "react-router-dom";
import { ATIVO_TIPO } from "@investirapri/financa.js/lib/enums";
import { PessoaImage, NumberTableCell } from "../../../../components/molecules";
import { PATHS } from "../../../../enums";
const DetalheTable = memo(props => {
  const {
    detalhe
  } = props;
  return <TableContainer id="table-container" sx={{
    overflow: "auto"
  }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell colSpan={4}></TableCell>
            <TableCell colSpan={5}>Operação</TableCell>
            <TableCell colSpan={6}>Análise</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}></TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              VNA
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              PU Par
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              Taxa Emissão
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              Taxa
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              PU
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right",
            width: "117px"
          }}>
              Quantidade
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right",
            width: "117px"
          }}>
              Financeiro
            </TableCell>

            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              Cotação
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              Prazo Médio(a)
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              Duration(a)
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              Duration
              <br />
              Modificada
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              Convexidade
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              Sensibilidade
              <br />
              <span style={{
              whiteSpace: "nowrap"
            }}>(Duration Mod.)</span>
            </TableCell>
            <TableCell sx={{
            verticalAlign: "bottom",
            textAlign: "right"
          }}>
              Sensibilidade
              <br />
              (Convexidade)
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {detalhe.map((xItem, xIndex) => {
          const bgColor = xIndex % 2 === 0 ? "secondary.darkness" : "secondary.dark";
          const xMercado = ATIVO_TIPO[xItem.ativo_tipo_id]?.mercado;
          const xPath = xMercado ? `/ativos${PATHS[xMercado.toLowerCase()].path}/${xItem.ifeed_ativo_id || xItem.ativo_id}` : null;
          return <React.Fragment key={crypto.randomUUID()}>
                {!validators.isEmpty(xItem.erros) && <TableRow sx={{
              backgroundColor: bgColor
            }}>
                    <TableCell colSpan={14} padding="none">
                      <Stack spacing={0.25}>
                        {xItem.erros.map((xErr, xErrIndex) => {
                    return <Alert key={`${xItem.isin}-erro-${xErrIndex}`} severity="warning" sx={{
                      py: 0.25,
                      borderRadius: 0
                    }} variant="outlined">
                              {xErr.descricao}
                            </Alert>;
                  })}
                      </Stack>
                    </TableCell>
                  </TableRow>}
                <TableRow sx={{
              backgroundColor: bgColor
            }}>
                  <TableCell>
                    {Boolean(xItem?.emissor?.logo_pessoa_id) && <Link to={xPath} target="_blank" rel="noopener noreferrer">
                        <PessoaImage logoPessoaId={xItem.emissor.logo_pessoa_id} alt={xItem?.emissor.pessoa_fantasia} hasLogo={Boolean(xItem?.emissor.logo_pessoa_id)} size={24} />
                      </Link>}
                  </TableCell>
                  <TableCell colSpan={5}>
                    <b>{xItem.ativo}</b>
                  </TableCell>
                  <TableCell colSpan={1}>
                    <b>{xItem.isin || "---"}</b>
                  </TableCell>
                  <TableCell colSpan={1} sx={{
                textAlign: "right"
              }}>
                    <b>{xItem.ativo_tipo || "---"}</b>
                  </TableCell>
                  <TableCell colSpan={2} sx={{
                textAlign: "right"
              }}>
                    {xItem.vencimento ? <b>Vencimento: {formats.formatDate(xItem.vencimento)}</b> : <b>---</b>}
                  </TableCell>

                  <TableCell colSpan={5}></TableCell>
                </TableRow>
                <TableRow sx={{
              backgroundColor: bgColor
            }}>
                  <TableCell></TableCell>
                  <NumberTableCell value={xItem.curva?.pu_vna} />
                  <NumberTableCell value={xItem.curva?.pu_par} />
                  <NumberTableCell value={xItem.pu_emissao} decimal={4} separateThousand={false} />
                  <NumberTableCell value={xItem.operacao?.taxa} decimal={4} separateThousand={false} />
                  <NumberTableCell value={xItem.operacao?.pu} decimal={6} />
                  <NumberTableCell value={xItem.operacao?.quantidade} decimal={6} />
                  <NumberTableCell value={xItem.operacao?.financeiro} decimal={2} />
                  <NumberTableCell value={xItem.operacao?.cotacao} decimal={6} separateThousand={false} />
                  <NumberTableCell value={xItem.analise?.prazo_medio} decimal={6} separateThousand={false} />
                  <NumberTableCell value={xItem.analise?.duration} decimal={6} separateThousand={false} />
                  <NumberTableCell value={xItem.analise?.duration_modificada} decimal={6} separateThousand={false} />
                  <NumberTableCell value={xItem.analise?.convexidade} decimal={6} separateThousand={false} />
                  <NumberTableCell value={xItem.analise?.duration_modificada_sensibilidade} decimal={6} separateThousand={false} sufix="%" />
                  <NumberTableCell value={xItem.analise?.convexidade_sensibilidade} decimal={6} separateThousand={false} sufix="%" />
                </TableRow>
              </React.Fragment>;
        })}
        </TableBody>
      </Table>
    </TableContainer>;
});
export default DetalheTable;
